import { minTrafficDate } from 'apps/placeme/src/features/Analyse/utils/constants'
import { useMemo } from 'react'
import { trafficVersions } from 'apps/placeme/src/constants/constants'
import { subDays } from 'date-fns'
import useFeatureFlags from './useFeatureFlags'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useTrafficVisMinMaxDates() {
  const { trafficVersion } = useFeatureFlags()

  const minDate = useMemo(() => minTrafficDate, [])

  const maxDate = useMemo(() => {
    switch (trafficVersion) {
      case trafficVersions.v3:
        return subDays(new Date().setHours(23, 59, 59, 999), 4)
      default:
        return new Date('2025-05-31T23:59:59.999')
    }
  }, [trafficVersion])

  return {
    minDate,
    maxDate,
    trafficVersion,
  }
}
